import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["open"]
const _hoisted_3 = { class: "govuk-details__summary" }
const _hoisted_4 = { class: "govuk-details__summary-text" }
const _hoisted_5 = { class: "govuk-details__text" }
const _hoisted_6 = {
  key: 1,
  class: "govuk-inset-text"
}
const _hoisted_7 = ["for"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, "Error:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = ["aria-describedby", "id", "name", "type", "autocomplete"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.fieldGroupId,
    class: _normalizeClass(_ctx.fieldGroupClassList)
  }, [
    (_ctx.field.details)
      ? (_openBlock(), _createElementBlock("details", {
          key: 0,
          open: _ctx.field.details.open,
          class: "govuk-details",
          "data-module": "govuk-details"
        }, [
          _createElementVNode("summary", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.field.details.label), 1)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.field.details.detail), 1)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.field.inset)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.field.inset), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", {
      class: "govuk-label",
      for: _ctx.field.name
    }, _toDisplayString(_ctx.field.label), 9, _hoisted_7),
    (_ctx.field.hint)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          id: _ctx.hintId,
          class: "govuk-hint"
        }, _toDisplayString(_ctx.field.hint), 9, _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.field.errors)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          id: _ctx.errorId,
          class: "govuk-error-message"
        }, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.field.errors, (error, index) => {
            return (_openBlock(), _createElementBlock("span", { key: index }, [
              _createTextVNode(_toDisplayString(error.error), 1),
              _hoisted_11
            ]))
          }), 128))
        ], 8, _hoisted_9))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      class: _normalizeClass(_ctx.inputClassList),
      "aria-describedby": _ctx.inputDescribedBy,
      id: _ctx.field.name,
      name: _ctx.field.name,
      type: _ctx.field.inputType,
      spellcheck: "false",
      autocomplete: _ctx.field.autocomplete
    }, null, 10, _hoisted_12), [
      [_vModelDynamic, _ctx.inputValue]
    ])
  ], 10, _hoisted_1))
}